import gql from 'graphql-tag';

export default gql`
  mutation deleteCustomRedirect($id: Int!) {
    delete_custom_redirects_by_pk(id: $id) {
      id
    }
  }
`;
